import { render, staticRenderFns } from "./shixizhidao.vue?vue&type=template&id=2f63ba90&scoped=true"
import script from "./shixizhidao.vue?vue&type=script&lang=js"
export * from "./shixizhidao.vue?vue&type=script&lang=js"
import style0 from "./shixizhidao.vue?vue&type=style&index=0&id=2f63ba90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX-JYJ\\WEB\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f63ba90",
  null
  
)

export default component.exports